import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  hashbang: false,
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      meta: { auth: undefined }
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: () => import(/* webpackChunkName: "press" */ './views/Impressum.vue'),
      meta: { auth: undefined }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import(/* webpackChunkName: "privacy" */ './views/Privacy.vue'),
      meta: { auth: undefined }
    },
    {
      path: '/facts',
      name: 'Facts',
      component: () => import(/* webpackChunkName: "facts" */ './views/Facts.vue'),
      meta: { auth: undefined }
    },
    {
      path: '/agb',
      name: 'Agb',
      component: () => import(/* webpackChunkName: "agb" */ './views/Agb.vue'),
      meta: { auth: undefined }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue'),
      meta: { auth: undefined },
    },
    {
      path: '/login',
      name: 'Login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      meta: { auth: undefined }
    },
    {
      path: '/',
      name: 'Dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/user/manage',
      name: 'ManageUser',
      component: () => import(/* webpackChunkName: "manage-user" */ './views/user/Manage.vue'),
      meta: {
        auth: {
          roles: ['ROLE_ADMIN'],
          redirect: { name: 'admin' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/user/profile',
      name: 'UserProfile',
      component: () => import(/* webpackChunkName: "user-profile" */ './views/user/Profile.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/event/manage',
      name: 'ManageEvent',
      component: () => import(/* webpackChunkName: "manage-event" */ './views/event/Manage.vue'),
      meta: {
        auth: {
          roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/message/manage',
      name: 'ManageMessage',
      component: () => import(/* webpackChunkName: "manage-message" */ './views/message/Manage.vue'),
      meta: {
        auth: {
          roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/hotel/create',
      name: 'CreateHotel',
      component: () => import(/* webpackChunkName: "create-hotel" */ './views/hotel/Create.vue'),
      meta: {
        auth: {
          roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/hotel/manage',
      name: 'ManageHotel',
      component: () => import(/* webpackChunkName: "edit-hotel" */ './views/hotel/Manage.vue'),
      meta: {
        auth: {
          roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/hotel/minimum/stay',
      name: 'MinimumStay',
      component: () => import(/* webpackChunkName: "minimum-stay-hotel" */ './views/hotel/MinimumStay.vue'),
      meta: {
        auth: {
          roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/hotel/dynamic',
      name: 'DynamicPriceAdmin',
      component: () => import(/* webpackChunkName: "dynamic-price-admin-hotel" */ './views/hotel/DynamicPriceAdmin.vue'),
      meta: {
        auth: {
          roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/report',
      name: 'Report',
      component: () => import(/* webpackChunkName: "report" */ './views/report/Manage.vue'),
      meta: {
        auth: {
          roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/rate/calendar',
      name: 'DynamicPrice',
      component: () => import(/* webpackChunkName: "dynamic-price-hotel" */ './views/hotel/DynamicPrice.vue'),
      meta: {
        auth: {
          roles: ['ROLE_MANAGER', 'ROLE_USER'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/rate/calculator',
      name: 'PriceCalculator',
      component: () => import(/* webpackChunkName: "price-calculator-hotel" */ './views/hotel/PriceCalculator.vue'),
      meta: {
        auth: {
          roles: ['ROLE_MANAGER', 'ROLE_USER'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/protocol',
      name: 'ViewProtocol',
      component: () => import(/* webpackChunkName: "dynamic-price-hotel" */ './views/hotel/Protocol.vue'),
      meta: {
        auth: {
          roles: ['ROLE_MANAGER', 'ROLE_USER'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/staff',
      name: 'HotelStaff',
      component: () => import(/* webpackChunkName: "hotel-staff" */ './views/hotel/Staff.vue'),
      meta: {
        auth: {
          roles: ['ROLE_MANAGER'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
    {
      path: '/test',
      name: 'Test',
      component: () => import(/* webpackChunkName: "test" */ './views/Test.vue'),
      meta: {
        auth: {
          roles: ['ROLE_ADMIN', 'ROLE_MODERATOR'],
          redirect: { name: 'adminOrMod' },
          forbiddenRedirect: '/dashboard',
        },
      },
    },
  ]
})
